module.exports = __webpack_public_path__ + "media/images/webpage/clips/press-9bf7af13d7d1ef9b5985dfaa3a352276.webp";